import { isEmailValidate, IsValidMobile, IsValidOTP, IsValidPassword } from './../validation';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomLoaderService } from '../services/custom-loader.service';
import { MainHeaderMenuService } from '../services/main-header-menu.service';
import { EncrdecrService } from './../Auth/encrdecr.service';
import { LoginService } from '../services/login.service';
import { ClientDataService } from '../services/client-data.service';
import { environment } from 'src/environments/environment.prod';
import { isNullOrUndefined } from '../validation';
import { ClientService } from '../services/client.service';
import { debug } from 'console';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { OtpComponent } from '../shared/otp/otp.component';
import { Subject } from 'rxjs';
import { TransactionService } from '../services/transaction.service';
import { ProfileService } from 'src/app/services/profile.service';
declare var $: any;

@Component({
  selector: 'app-nominee-preview-landing',
  templateUrl: './nominee-preview-landing.component.html',
  styleUrls: ['./nominee-preview-landing.component.scss']
})
export class NomineePreviewLandingComponent {
  UserPassword: string = "";
  txtLength = 0;
  LoginForm: FormGroup;
  LoginSubmitted: boolean = false;
  UserType: number = 3;
  IsShowLoginOption: boolean = true;
  WelcomeText: any = '';
  logo: string;
  NavHeight: string;
  IsMobile: boolean = false;
  logoWidth: string;
  logoHeight: string;
  IsAllowLogin: boolean = true;
  MobileLoginForm: FormGroup;
  isMobileLoginFormSubbmitted: boolean = false;
  isMobileListDisplay: boolean = false;
  EmailLoginForm: FormGroup;
  isEmailFormSubbmitted: boolean = false;
  isEmailListDisplay: boolean = false;
  ClientData: any = [];
  ClientDataBasedOnEmail: any = [];
  utm_source: string = "";
  SecondHolderID: string = "";
  characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  USERLoginId: any = '0';
  InvalidMessage = ""
  public bsModelRef: BsModalRef;
  um: any;
  ut: any;
  ue: any;
  un: any;
  up: any;
  ui: any;
  tm: any;
  Amount: any;
  n: any;
  TaxStatusId: any;
  ForCart: boolean = false;
  constructor(private LoginService: LoginService,
    private EncrdecrService: EncrdecrService,
    private ShowHideHeaderMenu: MainHeaderMenuService,
    private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private Loader: CustomLoaderService,
    private ClientDataService: ClientDataService, private clientservice: ClientService,
    private bsModelService: BsModalService,
    private transaction: TransactionService,private clientProfileService: ProfileService) {

  }
  ngOnInit() {
    //debugger
    this.route.queryParams.subscribe((queryParam) => {
      //debugger
      if (queryParam.utm_source != undefined) {
        this.ForCart = true
        this.utm_source = this.EncrdecrService.setEncr(queryParam.utm_source);
        sessionStorage.setItem("3erT@Qr65TdXwq1", this.utm_source);
      }
      if (queryParam.User != undefined) {
        let User = queryParam.User;
        sessionStorage.setItem("gzdghzvdghzvdc", User);
      }
      if (queryParam.UCCCODE != undefined) {
        let UCCCODE = this.EncrdecrService.setEncr(queryParam.UCCCODE);
        sessionStorage.setItem("W113TKilrF1u1gL", UCCCODE);
      }
      if (queryParam.SecondHolderCBId != undefined) {
        let SecondHolderCBId = this.EncrdecrService.setEncr(queryParam.SecondHolderCBId);
        sessionStorage.setItem("87r23rsdify8r493748", SecondHolderCBId);
      }
      if (queryParam.ThirdHolderCBId != undefined) {
        let ThirdHolderCBId = this.EncrdecrService.setEncr(queryParam.ThirdHolderCBId);
        sessionStorage.setItem("qwedq038ueq83d08", ThirdHolderCBId);
      }
      if (queryParam.holdingType != undefined) {
        let holdingType = this.EncrdecrService.setEncr(queryParam.holdingType);
        sessionStorage.setItem("76t7t65hgkyjiuy", holdingType);
      }

      if (queryParam.FirstHolder != undefined) {
        let FirstHolder = this.EncrdecrService.setEncr(queryParam.FirstHolder);
        sessionStorage.setItem("vsdjkfwi3493504osdkj", FirstHolder);

        sessionStorage.setItem("NOMINEEhxfvhjxvbxb", "1");
        this.Loader.show();
        const json = {
          "MobileNo": this.EncrdecrService.getDecr(this.utm_source),
          "Email": "",
          "flag": "BasedOnClientID",
          "UserType": this.UserType
        }
        let data = JSON.stringify(json)
        this.LoginService.fetchClientDetailsBasedOnMobileOrEmail(data).subscribe(
              (response: any) => {
                let res = JSON.parse(this.EncrdecrService.getDecr(response))
                //debugger;
                //this.Loader.hide();
                if (res.ArrayOfResponse != null && res.ArrayOfResponse != undefined) {
                  let password = this.EncrdecrService.getDecr(res.ArrayOfResponse[0].Password)
                  const json = {
                    "Username": res.ArrayOfResponse[0].PANNo,
                    "Password": password
                  }
                  let databody = JSON.stringify(json);
                  this.callAuthenticationController(databody)
                }
          })

      //   if(queryParam.LinkCurrentTime){
      //     let LinkCurrentTime = this.EncrdecrService.getDecr(queryParam.LinkCurrentTime)
      //     LinkCurrentTime = this.formatDate(LinkCurrentTime)
      //     let urldate = new Date(LinkCurrentTime)
      //     console.warn("urldate",urldate)
      //     if(urldate){
      //       let currentDate = new Date()
      //       let newdate = new Date(urldate.getTime()+24 * 60 * 60 * 1000)
      //       console.warn("newdate:",newdate)
      //       if(newdate >= currentDate){
      //   this.Loader.show();
      //   const json = {
      //     "MobileNo": this.EncrdecrService.getDecr(this.utm_source),
      //     "Email": "",
      //     "flag": "BasedOnClientID",
      //     "UserType": this.UserType
      //   }
      //   let data = JSON.stringify(json)
      //   this.LoginService.fetchClientDetailsBasedOnMobileOrEmail(data).subscribe(
      //     (response: any) => {
      //       let res = JSON.parse(this.EncrdecrService.getDecr(response))
      //       //debugger;
      //       //this.Loader.hide();
      //       if (res.ArrayOfResponse != null && res.ArrayOfResponse != undefined) {
      //         let password = this.EncrdecrService.getDecr(res.ArrayOfResponse[0].Password)
      //         const json = {
      //           "Username": res.ArrayOfResponse[0].PANNo,
      //           "Password": password
      //         }
      //         let databody = JSON.stringify(json);
      //         this.callAuthenticationController(databody)
      //       }
      //     })
      // }
      //       else{
      //         this.CallAlertModal('Link has been expired!');
      //       }
      //     }
      //     else{
      //       this.CallAlertModal('Something went wrong!');
      //     }
      //   }
      //   else{
      //     this.CallAlertModal('Something went wrong!');
      //   }
      }
    })
  }

  callAuthenticationController(DataBody: any){
    this.clientProfileService.getIPAddress().subscribe((res:any)=>{  
      //debugger
      let ipAddress=res.ip;
      this.callAuthenticationControllerMain(DataBody,ipAddress);
    },
    error => {
      this.callAuthenticationControllerMain(DataBody,"");
    })
  }

  callAuthenticationControllerMain(DataBody: any,IPADD:string = '') {
    //debugger
    this.Loader.show();
    sessionStorage.setItem('Tgsh@#3734fjfskshh==', IPADD);
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    this.LoginService.PostLogin_NSE_Info(DataBody, this.UserType, IpAddress).then(
      (res1: any) => {
        let resMessage = "";
        let res = JSON.parse(this.EncrdecrService.getDecr(res1));
        if (!isNullOrUndefined(res.Message)) {
          resMessage = res.Message;
        }
        else {
          resMessage = res;
        }
        if (resMessage != "Invalid Username and Password" && res.TOKEN_ID != null) {
          sessionStorage.setItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF', this.EncrdecrService.setEncr("1"));
          sessionStorage.setItem('YKHkxDnoSoOe6PdTjKrqfm4z6', this.EncrdecrService.setEncr("19"));
          sessionStorage.setItem('`huR,8@RK9^??b4 -.hfs!!uR,XX', res.TOKEN_ID);
          sessionStorage.setItem('F44sGAGh2xwkpUL', res.LOGIN_ID); // Session_SubBrokerId
          sessionStorage.setItem('V4WGROuLLBE6t98', res.USER_NAME); // Session_UserName
          sessionStorage.setItem('V8hpPfITcxhEI9x', res.EMAIL_ID); // Session_UserEmail

          sessionStorage.setItem('Xe003SRRyYEoOC2', res.MOBILE); // Session_UserMobile
          sessionStorage.setItem('pOWgAF62qFXnZMn', ''); // RazorCustId
          sessionStorage.setItem('Hldq31TLYwRbLJ8', res.SubBrokerCode); // Session_SubBrokerCode
          sessionStorage.setItem('L2D3506kIHSk3E0', res.USER_TYPE); // Session_UserType
          sessionStorage.setItem('qAkZrQYLWNBSlki', res.LOGIN_ID); // Session_CBId
          sessionStorage.setItem('pi4ZU2P3M8JE4q7', ''); // Session_B64CompanyLogo
          if (res.Family_ID !== null && res.Family_ID !== undefined && res.Family_ID !== 'null') {
            sessionStorage.setItem('hn0bHyGhfpGtrPe', res.Family_ID);  // Session_Family_ID
          }
          let ut = res.USER_TYPE;
          //debugger
          if (ut != undefined && ut != null && ut != '') {
            if (this.EncrdecrService.getDecr(ut) == '3') {
              sessionStorage.setItem('m5JkoXISmYRAIuY', res.USER_ID);
              this.USERLoginId = res.USER_ID;
              sessionStorage.setItem('UZT6qHaDZSz66kx', res.LOGIN_ID); // Session_ClientBasicInfoId
              sessionStorage.setItem('N1QJHdOkO7Hz8QC', res.LOGIN_ID);
              sessionStorage.setItem('ySxterqMDG7RY2qTpuzrfA', this.EncrdecrService.setEncr("1"));

              sessionStorage.setItem('AqVk7klfa+b0nlVjO8Y90I=', res.RiskProfile); //Aggressive/Moderate etc
              sessionStorage.setItem('aaIHl0pIiYe71gyyxC/5xA==', res.RiskProfileStatus);//Active or Expired
              sessionStorage.setItem('LWHTWnSDkv4+qaQXsO6tHYU=', res.RiskProfileLevel); //risk Level of client
              sessionStorage.setItem('6l0NqN5kkIZCaDvdzUfYVK8g=', res.RiskProfileInsertedDate);
              if (sessionStorage.getItem("rfrg343") == undefined && sessionStorage.getItem("rfrg343") == null && sessionStorage.getItem("rfrg343") !== "Cart") {
                this.Loader.hide();
              }
              sessionStorage.setItem("3erT@Qr65TdXwq1", res.LOGIN_ID);
              sessionStorage.setItem('TF4q3aPcsYpaEDoa4ROM', res.TxStatus); //TxStatusId of Client
              sessionStorage.setItem('cABJtw0TY2XnfyQkiMI4', res.ClientType);
              if (sessionStorage.getItem("rfrg343") !== undefined && sessionStorage.getItem("rfrg343") !== null && sessionStorage.getItem("rfrg343") == "Cart") {
                // this.Loader.hide()
                this.router.navigateByUrl('/transaction-new-latest/cart');
                return
              }
              else if (this.utm_source == "") {
                sessionStorage.setItem("3erT@Qr65TdXwq1", res.LOGIN_ID);
                //aditya
                //window.location.href = '/Client-Profile-Preview/Preview'
                window.location.href = '/client-dashboard'
              }
              else if (this.utm_source == res.LOGIN_ID) {
                sessionStorage.setItem("3erT@Qr65TdXwq1", res.LOGIN_ID);
                //aditya
                window.location.href = '/nominee-preview'
                //window.location.href = '/client-dashboard'
              }
              else if ((this.utm_source != res.LOGIN_ID)) {
                this.CallAlertModal("Please select the correct user to proceed.");
                sessionStorage.clear();
                return;
              }
              // else {
              //   window.location.href = '/dashboard';
              // }

              //Microsoft Clarity Code Starts
              let id = this.USERLoginId;

              if (id != null && id != undefined && id != '') {
                id = this.EncrdecrService.getDecr(id);
                sessionStorage.removeItem('cl2342wrty'); ///21062024
                sessionStorage.setItem('cl2342wrty', id)
              }

              // setTimeout(() => {
              //   $("#addedScript").remove();
              //   var head = document.getElementsByTagName('head')[0];
              //   var script = document.createElement('script');
              //   script.type = 'text/javascript';
              //   script.setAttribute('id', 'addedScript');
              //   script.text = `
              //   //debugger
              //   let clid = sessionStorage.getItem('cl2342wrty')
              //   let currentUserId = '0' ;
              //   if(clid != null && clid != undefined && clid != ''){
              //       currentUserId = clid;
              //   }

              //   (function(c,l,a,r,i,t,y){
              //     c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              //     t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              //     y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
              //     clarity("set", "userId", currentUserId.toString());
              //     console.log(currentUserId.toString())
              // })(window, document, "clarity", "script", "myvdl8jnsv");
              //   `
              //   head.appendChild(script);
              // }, 500);
              //Microsoft Clarity Code Ends

            }
            else {
              this.CallAlertModal('Please enter valid username and password');
            }
          }
          else {
            this.CallAlertModal('Please enter valid username and password');
          }
        }
        else if (resMessage.includes("This feature is not available for your login")) {
          // this.CallAlertModal(resMessage);
          this.CallAlertModal("To activate your login, please contact your distributor")
        }
        else {
          this.CallAlertModal('Please enter valid username and password');
        }
        this.Loader.hide();
      },
      (err: any) => {
        const rr = err.error;
        const er = rr.substring(1, rr.length - 1);
        const rk = er.split(', ');
        this.Loader.hide();
        this.CallAlertModal('Please enter valid username and password');
      }
    );
  }
  CallAlertModal(msg: any) {
    $('#AlertModal').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContent').text(msg);
  }
  
  formatDate(inputDate) {
    const parts = inputDate.split(/[\/\s:]/);
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
    const hours = parts[3];
    const minutes = parts[4];
    const seconds = parts[5];
  
    const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
  }
  


}
